import React, { Component } from "react";

// Import components
import DashboardProducts from "./Products/DashboardProducts";
// import DashboardLoader from './Loader/DashboardLoader';
import DashboardConsolExclutions from "./Exclusions/DashboardConsolExclusions";
import DashboardConsolExclutionsTempUnable from "./Exclusions/DashboardConsolExclutionsTempUnable";

import DashboardUsersRoll from "./UsersRoll/DashboardUsersRoll";

//constante usada en todos los roles
const dataSelectedCountry = (country) => {
  return [
    {
      id: "products",
      headerTitle: "ADMINISTRACIÓN DE PRODUCTOS",
      label: "Productos",
      component: (
        <DashboardProducts countriesCode={country} userRoll={"Editor"} />
      ),
    },
    // {
    //   id: "loader",
    //   headerTitle: "DATA LOADER",
    //   label: "Historial de carga masiva",
    //   component: <DashboardLoader
    //                 userRoll={"Editor"}
    //                 countriesCode={country}
    //             />
    // },
  ];
};

//variables segun roll
const Administrator = (dataPropsAdmin) => {
  // console.log(dataPropsAdmin)
  // if(dataPropsAdmin.countriesCode === "mdmexico"){
  //   return dataSelectedCountry(dataPropsAdmin.countriesCode);
  // }else{
  const data = [
    {
      id: "products",
      headerTitle: "ADMINISTRACIÓN DE PRODUCTOS",
      label: "Productos",
      component: (
        <DashboardProducts countriesCode={dataPropsAdmin.countriesCode} />
      ),
    },
    // {
    //   id: "inclusions",
    //   headerTitle: "Inclusión por Centro de distribución".toUpperCase(),
    //   label: "Historial de carga masiva",
    //   component: <DashboardConsolExclutions
    //                 countriesCode={dataPropsAdmin.countriesCode}
    //               />
    // },
    // {
    //   id: "loader",
    //   headerTitle: "DATA LOADER",
    //   label: "Historial de carga masiva",
    //   component: <DashboardLoader
    //                 countriesCode={dataPropsAdmin.countriesCode}
    //               />
    // },
  ];

  if (dataPropsAdmin.countriesCode !== "mdcolombia")
    data.push({
      id: "exclusions",
      headerTitle: "CONSOLIDADO DE EXCLUSIONES",
      label: "Historial de carga masiva",
      component: (
        <DashboardConsolExclutions
          countriesCode={dataPropsAdmin.countriesCode}
        />
      ),
    });

  return data;
  // }
};

const Editor = (dataPropsEditor) => {
  // if(dataPropsEditor.countriesCode === "mdmexico"){
  //   return dataSelectedCountry(dataPropsEditor.countriesCode)
  // }else{
  const data = [
    {
      id: "products",
      headerTitle: "ADMINISTRACIÓN DE PRODUCTOS",
      label: "Productos",
      component: (
        <DashboardProducts
          countriesCode={dataPropsEditor.countriesCode}
          userRoll={"Editor"}
        />
      ),
    },
    // {
    //   id: "loader",
    //   headerTitle: "DATA LOADER",
    //   label: "Historial de carga masiva",
    //   component: <DashboardLoader
    //                 userRoll={"Editor"}
    //                 countriesCode={dataPropsEditor.countriesCode}
    //             />
    // },
  ];

  if (dataPropsEditor.countriesCode !== "mdcolombia")
    data.push({
      id: "exclusions",
      headerTitle: "CONSOLIDADO DE EXCLUSIONES",
      label: "CONSOLIDADO DE EXCLUSIONES",
      component: (
        <DashboardConsolExclutions
          userRoll={"Editor"}
          countriesCode={dataPropsEditor.countriesCode}
        />
      ),
    });

  return data;

  // }
};

const Reader = (dataPropsReader) => {
  // if(dataPropsReader.countriesCode === 'mdmexico'){
  //   return dataSelectedCountry(dataPropsReader.countriesCode)
  // }else{

  if (dataPropsReader.countriesCode !== "mdcolombia")
    return [
      {
        id: "exclusions",
        headerTitle: "CONSOLIDADO DE EXCLUSIONES",
        label: "CONSOLIDADO DE EXCLUSIONES",
        component: (
          <DashboardConsolExclutions
            userRoll={"Lector"}
            countriesCode={dataPropsReader.countriesCode}
          />
        ),
      },
    ];
  else
    return [
      {
        id: "exclusions",
        headerTitle: "CONSOLIDADO DE EXCLUSIONES",
        label: "CONSOLIDADO DE EXCLUSIONES",
        component: (
          <DashboardConsolExclutionsTempUnable
            userRoll={"Lector"}
            countriesCode={dataPropsReader.countriesCode}
          />
        ),
      },
    ];
  // }
};

export default class DashboardMenu extends Component {
  state = {
    selected: 0,
    menu:
      this.props.userData.user.clientPermission === "Administrador"
        ? Administrator(this.props)
        : this.props.userData.user.clientPermission === "Editor"
        ? Editor(this.props)
        : Reader(this.props),
    // menu: Administrator('mdcolombia')
  };

  handleMenu = (evt) => {
    const dataMenuItem = evt.target.dataset.menuItem;

    this.setState({
      selected: parseInt(dataMenuItem),
    });
    if (evt.target.classList[1] === "usersroll") {
      this.props.setHeaderTitle("ADMINISTRACION DE USUARIOS");
      this.props.setViewContent(
        <DashboardUsersRoll
          userData={this.props.userData}
          countriesCode={this.props.countriesCode}
        />
      );
    } else {
      this.props.setViewContent(this.state.menu[dataMenuItem].component);
      this.props.setHeaderTitle(this.state.menu[dataMenuItem].headerTitle);
    }
  };

  componentDidMount() {
    this.props.setViewContent(this.state.menu[this.state.selected].component);
    this.props.setHeaderTitle(this.state.menu[this.state.selected].headerTitle);
  }

  render() {
    return (
      <div className="dashboard__menu">
        <ul className="dashboard__menu-items">
          {this.state.menu.map((element, index) => (
            <li
              className={`dashboard__menu-item ${
                index === this.state.selected ? "selected" : ""
              }`}
            >
              <div
                className={`dashboard__icon ${element.id}`}
                data-menu-item={index}
                onClick={this.handleMenu}
              >
              </div>
            </li>
          ))}
        </ul>
        {this.props.userData.user.clientPermission === "Administrador" ? (
          <ul className="dashboard__menu-items">
            <li
              className={`dashboard__menu-item ${
                2 === this.state.selected ? "selected" : ""
              }`}
            >
              <div
                className={`dashboard__icon usersroll`}
                data-menu-item={2}
                onClick={this.handleMenu}
              ></div>
            </li>
          </ul>
        ) : (
          ""
        )}
      </div>
    );
  }
}
